import { cn } from "@/lib/utils";

export type InboxTab = "all" | "email" | "texts" | "starred";

type Props = {
  activeTab: InboxTab;
  onTabChange: (tab: InboxTab) => void;
  cutBs: boolean;
  onCutBsChange: (val: boolean) => void;
  hiddenCount: number;
};

const tabs: { value: InboxTab; label: string }[] = [
  { value: "all", label: "All" },
  { value: "email", label: "Email" },
  { value: "texts", label: "Texts" },
  { value: "starred", label: "Starred" },
];

export function InboxFilters({ activeTab, onTabChange, cutBs, onCutBsChange, hiddenCount }: Props) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <div className="flex gap-1">
        {tabs.map((tab) => (
          <button
            key={tab.value}
            onClick={() => onTabChange(tab.value)}
            className={cn(
              "px-3 py-1.5 rounded-full text-xs font-medium transition-colors",
              activeTab === tab.value
                ? "bg-primary text-primary-foreground"
                : "bg-muted text-muted-foreground hover:text-foreground"
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <button
        onClick={() => onCutBsChange(!cutBs)}
        className={cn(
          "ml-auto px-3 py-1.5 rounded-full text-xs font-medium transition-colors border",
          cutBs
            ? "bg-accent/20 text-accent border-accent/30"
            : "bg-muted text-muted-foreground border-transparent hover:text-foreground"
        )}
      >
        Cut the BS
        {cutBs && hiddenCount > 0 && (
          <span className="ml-1 text-[10px] opacity-70">({hiddenCount} hidden)</span>
        )}
      </button>
    </div>
  );
}
